import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';
import { ResponseErrorPanel } from '@backstage/core-components';

const useStyles = makeStyles(
  theme => ({
    backButton: {
      marginRight: theme.spacing(1),
    },
    footer: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'right',
      marginTop: theme.spacing(2),
    },
  }),
  { name: 'BackstageTemplateStepper' },
);

export const ErrorPanel = (props: {
  error: Error;
  handleBack: () => void;
  disabled?: boolean;
}) => {
  const styles = useStyles();
  const { error, handleBack, disabled } = props;
  return (
    <>
      <ResponseErrorPanel
        error={{ name: error.name, message: error.message }}
      />
      <div className={styles.footer}>
        <Button
          onClick={handleBack}
          color="primary"
          className={styles.backButton}
          disabled={disabled}
          variant="contained"
        >
          Back
        </Button>
      </div>
    </>
  );
};
